<div class="container">
  <div class="row">
    <div class="myroche-bg">
      <div class="cards-row">
        <div class="myroche-card">

          <rds-badge label="GENERALLY AVAILABLE" color="neutral" size="m"></rds-badge>
          <h2 class="my-8 article-heading-4">RocheHome</h2>
          <p class="ui-label-s">
            The current intranet is available to all employees. This will remain accessible until 31 March 2026.
          </p>
          <button rds-secondary-button class="my-8 card-btn" (click)="goOutside(false)">Launch RocheHome</button>
        </div>
        <div class="myroche-card">
          <rds-badge label="BETA MODE" color="warning" size="m" ></rds-badge>
          <h2 class="my-8 article-heading-4">myRoche</h2>
          <p class="ui-label-s">
            The new intranet, currently in beta mode with some key functionalities available, set to replace RocheHome
            on 1 April 2026.
          </p>
          <button rds-secondary-button class="my-8 card-btn" (click)="goOutside(true)">Launch myRoche (beta)</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div style="margin: 0 auto; width: auto; width: auto;">
      <div class="ui-label-m-bold question-title">Do you have any questions?</div>
      <div class="my-2 ui-body-s text-low-contrast">Please reach out to <a href="mailto:{{(contactEmail$ | async)}}" style="color: unset !important;">{{contactEmail$ | async}}</a></div>
    </div>
  </div>
</div>
